// Envelope (de)serialization: assemble the three data_json blobs from the live models
// (+ the opening-derived identity / dimension snapshots), and rebuild the models from a
// stored blob. The design bodies are handled by each model's toDesign/fromDesign; this
// layer just wraps the envelope. See ../data-json-dtos.md.

import {Opening} from "../../../../../api/Openings";
import {UnitSystem} from "../../../../../api/Projects";
import {HardwareGroupWithContent} from "../../../../../api/Hardware";
import {ELEVATION_DTO_VERSION, ElevationIdentity} from "../../../../../api/elevationTool/shared";
import {ScreenElevationData} from "../../../../../api/elevationTool/ScreenElevationData";
import {DoorElevationData} from "../../../../../api/elevationTool/DoorElevationData";
import {HardwareElevationData} from "../../../../../api/elevationTool/HardwareElevationData";
import {MdFrameSpec} from "../model/frame/MdFrameSpec";
import {MdDoorSpec} from "../model/door/MdDoorSpec";
import {MdHardware} from "../model/hardware/MdHardware";
import {dimensionFingerprintFromOpening} from "./frmVar";

// the identity is passed in (not re-derived from the opening) because the tool owns some
// Synced identity fields live — frameProfile is edited via MdFrameSpec.setProfile and
// would be lost if we re-read the opening's stale column here. save() builds it.
export function screenToData(frame: MdFrameSpec, identity: ElevationIdentity, opening: Opening): ScreenElevationData {
    return {
        version: ELEVATION_DTO_VERSION,
        identity: identity,
        dimensionFingerprint: dimensionFingerprintFromOpening(opening),
        frame: frame.toDesign(),
    };
}

export function screenFromData(data: ScreenElevationData, opening: Opening, hardware: HardwareGroupWithContent | null, sys: UnitSystem): MdFrameSpec {
    return MdFrameSpec.fromDesign(data.frame, opening, hardware, sys);
}

export function doorToData(door: MdDoorSpec, identity: ElevationIdentity, opening: Opening): DoorElevationData {
    return {
        version: ELEVATION_DTO_VERSION,
        identity: identity,
        dimensionFingerprint: dimensionFingerprintFromOpening(opening),
        door: door.toDesign(),
    };
}

export function doorFromData(data: DoorElevationData, opening: Opening, hardware: HardwareGroupWithContent | null, sys: UnitSystem, frame: MdFrameSpec): MdDoorSpec {
    return MdDoorSpec.fromDesign(data.door, opening, hardware, sys, frame);
}

export function hardwareToData(hardware: MdHardware, identity: ElevationIdentity, opening: Opening): HardwareElevationData {
    return {
        version: ELEVATION_DTO_VERSION,
        identity: identity,
        hardwareGroup: opening.hardwareGroup ?? 0,
        dimensionFingerprint: dimensionFingerprintFromOpening(opening),
        hardware: hardware.toDesign(),
    };
}

export function hardwareFromData(data: HardwareElevationData, opening: Opening, hardwareGroup: HardwareGroupWithContent | null, sys: UnitSystem, frame: MdFrameSpec, door: MdDoorSpec): MdHardware {
    return MdHardware.fromDesign(data.hardware, opening, hardwareGroup, sys, frame, door);
}
